// actions.js
import { createActions } from 'reduxsauce';

const { Creators, Types } = createActions({
    getContractReviewInitialData: ['initialData'],
});

export default { Creators, Types };

